import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor() { }
  isNavbarCollapsed = false;
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/navbar/navbar.component.ts